import { Action } from '@ngrx/store';

export const REGISTRAR_CLIENTE = '[reducerCliente] registrarCliente';
export const REGISTRO_LISTA = '[reducerLista] registroLista';

export class RegistrarclienteAction implements Action {
    readonly type = REGISTRAR_CLIENTE;
    constructor(public registroCliente: any) { }
}

export class RegistroListaAction implements Action {
    readonly type = REGISTRO_LISTA;
    constructor(public listas: any) { }
}

export type actions = RegistrarclienteAction | RegistroListaAction;   